var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home pt-3"},[_c('transition',{attrs:{"name":"animate-route","mode":"out-in","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('article-list',{attrs:{"articles":_vm.articles}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }